import * as angular from 'angular';
import BalanceNotificationsDao from "./notifications/balance.notifications.dao";
import BalanceNotificationsService from "./notifications/balance.notifications.service";

export default angular.module('CrazyWeb.Account.Balance', [])
    .service("BalanceNotifications", BalanceNotificationsDao)
    .service("BalanceNotificationsService", BalanceNotificationsService)
    .name
